/**
 * 全站配置
 */

export default {
  // 路由前缀
  routePrefix: 'account',
  // 请求超时时间
  timeout: 10000,
};

/* eslint-disable */

// https://webpack.js.org/guides/public-path/
// const { okGlobal = {} } = window;
// if (process.env.QA_ENV) {
//   __webpack_public_path__ = "http://localhost:3003/";
// } else {
//   __webpack_public_path__ = `${okGlobal.ACCOUNT_STATIC_UTL}/`; // eslint-disable-line
// }
